<template>
  <v-container class="py-12">
    <div class="text-center mb-12">
      <h1 class="text-h4 text-sm-h3">Bienvenue</h1>

      <div class="subtitle-1 text--secondary mt-2">
        Connectez-vous pour postuler aux offres d'emplois
      </div>
    </div>

    <v-card
      width="400"
      class="mx-auto rounded-lg"
      :loading="loading"
    >
      <v-card-title class="justify-center">
        <v-img
          :src="require('@/assets/undraw_authentication_fsn5.svg')"
          height="100"
          contain
        ></v-img>
        Connexion
      </v-card-title>

      <v-card-text>
        <v-form ref="form" @submit.prevent="login">
          <v-text-field
            label="Adresse e-mail"
            v-model="credentials.email"
            :rules="rules.email"
            validate-on-blur
            :error-messages="emailErrorText"
            @change="emailErrorText = ''"
            outlined
            :disabled="loading"
            hint="Utilisez une adresse privée, pas votre identifiant Condorcet"
            persistent-hint
          ></v-text-field>

          <v-text-field
            label="Mot de passe"
            v-model="credentials.password"
            :rules="rules.password"
            validate-on-blur
            :error-messages="passErrorText"
            @change="passErrorText = ''"
            outlined
            :append-icon="passIsVisible ? 'mdi-eye-off' : 'mdi-eye'"
            :type="passIsVisible ? 'text' : 'password'"
            @click:append="passIsVisible = !passIsVisible"
            :disabled="loading"
          ></v-text-field>

          <v-btn
            color="primary"
            block
            :disabled="loading"
            x-large
            type="submit"
          >
            Se connecter
          </v-btn>
        </v-form>
      </v-card-text>

      <v-card-actions class="justify-center">
        <router-link to="/forgotten-password">Mot de passe oublié ?</router-link>
      </v-card-actions>
    </v-card>

    <div class="mt-6 text-center">
      <span>Pas de compte ? </span>
      <router-link to="/register">Créez-en un ici !</router-link>
    </div>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import rulesMixin from '@/mixins/rulesMixin';

export default {
  name: 'Login',

  mixins: [rulesMixin],

  data: () => ({
    passIsVisible: false,
    loading: false,
    credentials: {
      email: '',
      password: '',
    },
    emailErrorText: '',
    passErrorText: '',
  }),

  methods: {
    ...mapActions(['authenticate', 'getUserData']),

    login() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      this.authenticate(this.credentials)
        .then(() => {
          this.getUserData()
            .then(() => {
              this.$router.push(this.$route.query.redirect || '/');
            })
            .catch(() => {
              this.$store.commit('SET_SNACKBAR', {
                isActive: true,
                text: 'Impossible de récupérer les infos de votre profil, réessayez',
              });
            });
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.emailErrorText = 'L\'adresse e-mail n\'a pas été trouvée';
          } else if (error.response.status === 401) {
            this.passErrorText = 'Mot de passe invalide';
          } else if (error.response.status === 403) {
            this.$store.commit('SET_SNACKBAR', {
              isActive: true,
              text: 'Veuillez activer votre compte via l\'email envoyé',
            });
          } else {
            this.$store.commit('SET_SNACKBAR', {
              isActive: true,
              text: 'Un problème est survenu lors de la connexion',
            });
          }
        })
        .finally(() => { this.loading = false; });
    },
  },
};
</script>
